import $ from 'jquery'; // @$el.toggleModifier "m-extra-wide", @model.get("collapsed")

(function ($) {
  $.fn.toggleModifier = function (modifier, condition) {
    if (condition) {
      return $(this).attr(modifier, '');
    } else {
      return $(this).removeAttr(modifier);
    }
  };
})($);